import Vue from 'vue';

import { IAvailabilityIngestion } from '@/bundles/AvailabilityIngestion/types';
import { Nullable } from '@/utils/types';

import { AvailabilityIngestionMutationsEnum } from './availability-ingestion-types';
import { IAvailabilityIngestionListing, IAvailabilityIngestionStore } from './index';

export default {
  [AvailabilityIngestionMutationsEnum.UpsertRecord] (state: IAvailabilityIngestionStore, record: IAvailabilityIngestion) {
    Vue.set(state.records, record._key, record);
  },

  [AvailabilityIngestionMutationsEnum.UpsertRecords] (state: IAvailabilityIngestionStore, records: IAvailabilityIngestion[]) {
    records.forEach((record) => {
      Vue.set(state.records, record._key, record);
    });
  },

  [AvailabilityIngestionMutationsEnum.SetListing] (
    state: IAvailabilityIngestionStore,
    { key, listing }: { key: string; listing: IAvailabilityIngestionListing },
  ) {
    Vue.set(state.listings, key, listing);
  },

  [AvailabilityIngestionMutationsEnum.SetListingLoading] (
    state: IAvailabilityIngestionStore,
    { key, loading }: { key: string; loading: boolean },
  ) {
    const existing: IAvailabilityIngestionListing = state.listings[key] ?? { ids: [], loading: false, error: null };
    Vue.set(state.listings, key, { ...existing, loading });
  },

  [AvailabilityIngestionMutationsEnum.SetListingError] (
    state: IAvailabilityIngestionStore,
    { key, error }: { key: string; error: Nullable<string> },
  ) {
    const existing: IAvailabilityIngestionListing = state.listings[key] ?? { ids: [], loading: false, error: null };
    Vue.set(state.listings, key, { ...existing, error });
  },
};
